import { parseTheme } from 'mol-ui';
import styled from 'styled-components';

export const UpdateBar = styled.div `
    align-items: center;
    bottom: 20px;
    display: flex;
    justify-content: center;
    left: 20px;
    position: absolute;
    z-index: 999;
`;

export const UpdateLink = styled.div `
    ${ parseTheme('background-color', 'primaryColor') }
    border-radius: 15px;
    color: white;
    cursor: pointer;
    padding: 15px;
    text-align: center;
`;
